export default {
  LOAD_SURVEY_FORM_PAGE_START: 'LoadSurveyFormPageStart',
  LOAD_SURVEY_FORM_PAGE_END: 'LoadSurveyFormPageEnd'
};